import {match} from 'ts-pattern';

import {lazy} from 'react';

import {ReportAccessGuard, useImporterReportingIntegrations} from '@dms/shared-aftersales';

const Report = lazy(() => import('./components/Report'));

interface Report5starCstarProps {
  type: '5star' | 'cstar';
}

export function Report5starCstar(props: Report5starCstarProps) {
  const {isMerc5StarEnabled, isMercCstarEnabled, isLoading, isError} =
    useImporterReportingIntegrations();

  const isEnabled = match(props.type)
    .with('5star', () => isMerc5StarEnabled)
    .with('cstar', () => isMercCstarEnabled)
    .exhaustive();

  return (
    <ReportAccessGuard
      hasAccess={isEnabled}
      isLoading={isLoading}
      isError={isError}
      data-testid="report5starCstar"
    >
      <Report key={props.type} type={props.type} />
    </ReportAccessGuard>
  );
}
